import utils from 'blue-utils';
import publicMutation from '$config/store/mutations';

//扩展公共的mutations
const mutations = utils.extend(publicMutation, {
  /*项目相关mutation*/
	
	
	add(state, item) {
		if (state.catchPages.indexOf(item) === -1)
			state.catchPages.push(item);
	},
	remove(state, item) {
		let index = state.catchPages.indexOf(item);
		if(index >0)
			state.catchPages.splice(index, 1)
	},
	
	/*申请直播流程中选择的资讯 -t*/
	addInfo(state, item){
		if (state.selectInfo.indexOf(item) === -1)
			state.selectInfo.push(item);
	},
	removeInfo(state, item) {
		let index = state.selectInfo.indexOf(item);
		if (index > -1) {
			state.selectInfo.splice(index, 1);
		}
	},
	/*申请直播流程中选择的资讯 -e*/
	/*申请直播流程中选择的商品 -t*/
	addGoods(state, item){
		if (state.selectGoods.indexOf(item) === -1)
			state.selectGoods.push(item);
	},
	removeGoods(state, item) {
		let index = state.selectGoods.indexOf(item);
		if(index > -1)
			state.selectGoods.splice(index, 1)
	},
	emptyGoods(){},
	/*申请直播流程中选择的商品 -e*/

//	地图选址地址
	setAddressValue(state, value){
		state.selectAddressValue = value;
	}
	
});

export default mutations;
